import MyLoader from '../UI/MyLoader/MyLoader';
import './NotFound.css';

const NotFound: React.FC = () => {
    return (
        <div className="notFound">
            <h1>
                Страница не найдена...
            </h1>
            <MyLoader />
        </div>
    )
}

export default NotFound